import request from '@/plugins/request';

export function getPdf(data) {
	return request({
		url: '/storagemanage/api/conDeputeContractBackSettlement/getReleaseAgreementDetail',
		method: 'get',
		params: data
	});
}

export function sendSignMobileCodeReq(data) {
	return request({
		url: '/storagemanage/api/esign/sendSignMobileCode3rd',
		method: 'get',
		params: data
	});
}

export function sign(data) {
	return request({
		url: '/storagemanage/api/esign/releaseAgreementSignature',
		method: 'post',
		data: data
	});
}


